import React from 'react'
import Page from 'components/LayoutComponents/Page'
import Helmet from 'react-helmet'
import Repository from './Repository'

function RepositoryPage(props) {
  return (
    <Page {...props}>
      <Helmet title="Cobranças" />
      <Repository />
    </Page>
  )
}

RepositoryPage.defaultProps = {
  pathName: 'Cobranças',
  roles: []
}

export default RepositoryPage
